document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.faq-tabs-section');
  
  sections.forEach(section => {
    const wrapper = section.querySelector('.faq-tabs-wrapper');
    
    // Create navigation container
    const navigation = document.createElement('div');
    navigation.className = 'faq-tabs-navigation';
    
    // Get all tab buttons and content areas
    const tabButtons = wrapper.querySelectorAll('.faq-tab-button');
    const tabContents = wrapper.querySelectorAll('.faq-tab-content');
    
    // Move all buttons to navigation
    tabButtons.forEach(button => {
      navigation.appendChild(button);
    });
    
    // Insert navigation before wrapper
    wrapper.parentNode.insertBefore(navigation, wrapper);
    
    // Initialize: Show first tab and open its first FAQ
    if (tabButtons.length > 0) {
      tabButtons[0].classList.add('active');
      tabContents[0].classList.add('active');
      
      // Open first FAQ in first tab
      const firstFaq = tabContents[0].querySelector('.faq-item');
      if (firstFaq) {
        firstFaq.classList.add('active');
        firstFaq.querySelector('.faq-question').setAttribute('aria-expanded', 'true');
      }
    }
    
    // Tab click handlers
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', function() {
        // Remove active from all tabs
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
        
        // Add active to clicked tab
        this.classList.add('active');
        tabContents[index].classList.add('active');
        
        // Close all FAQs in newly shown tab
        const faqItems = tabContents[index].querySelectorAll('.faq-item');
        faqItems.forEach(item => {
          item.classList.remove('active');
          item.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        });
        
        // Open first FAQ in newly shown tab
        const firstFaq = tabContents[index].querySelector('.faq-item');
        if (firstFaq) {
          firstFaq.classList.add('active');
          firstFaq.querySelector('.faq-question').setAttribute('aria-expanded', 'true');
        }
      });
    });
    
    // FAQ accordion handlers
    const allFaqItems = section.querySelectorAll('.faq-item');
    allFaqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      
      question.addEventListener('click', function() {
        const parentTab = item.closest('.faq-tab-content');
        const isActive = item.classList.contains('active');
        
        // Close all FAQs in this tab
        const siblingItems = parentTab.querySelectorAll('.faq-item');
        siblingItems.forEach(otherItem => {
          otherItem.classList.remove('active');
          otherItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        });
        
        // Toggle current FAQ
        if (!isActive) {
          item.classList.add('active');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
});